import React, { useState } from "react";
import { connect, ConnectedProps } from "react-redux";
import { Box } from "@material-ui/core";
import { Order } from "../../Shared/GeneratedTypes";
import { Localizations } from "../../Shared/sharedTypes";

interface propsType {
    order: Order;
    localizations: Localizations;
}
export default function ClientSplashScreen({ order, localizations }: propsType) {
    let defaultLogo = "/images/GuideStream360Logo-dark.png";
    let bgColor = "#FFFFFF";
    let textColor = "#000000";

    function getLogo() {
        return order != null && order.customer.useCustomerLaunchScreen ? order.launchPhotoUrl : defaultLogo
    }

    if (order != null && order.customer.useCustomerLaunchScreen) {
        bgColor = order.customer.launchScreenBgColor != null ? order.customer.launchScreenBgColor : "#FFFFFF";
        textColor = order.customer.launchScreenTextColor != null ? order.customer.launchScreenTextColor : "#000000";
    }

    return (
        <div
            className={
                order != null && !order.customer.useCustomerLaunchScreen
                    ? "splash transparentBackground"
                    : "splash transparentBackground-custom"
            }
            style={{
                backgroundColor: order != null && !order.customer.useCustomerLaunchScreen ? "#85c441" : bgColor,
            }}
        >
            <Box textAlign="center" marginTop={1}>
                <img
                    src={getLogo()}
                    alt="Powered by Guide Stream 360"
                    style={{
                        objectFit: "scale-down",
                        marginBottom: 0,
                        maxWidth: "90%",
                        filter: "drop-shadow(rgba(0, 0, 0, 0.5) 3px 2px 11px)",
                        display: order != null ? "inherit" : "none" //hide until order loads to prevent flashing of wrong logo
                    }}
                />
            </Box>
            <span style={{ color: order != null && !order.customer.useCustomerLaunchScreen ? "#FFFFFF" : textColor }}>
                {order != null ? localizations.PoweredBy : ""}
            </span>
        </div>
    );
}
